export const CHART_TYPES = {
  SEVERITY: "severity",
  AUTO_RESOLVED: "autoResolved",
  TRIGGERED_ALERT_BREAKDOWN: "triggeredAlertBreakdown",
  RESOLUTION_DURATION_BREAKDOWN: "resolutionDurationBreakdown",
};
